// extracted by mini-css-extract-plugin
export default {"f":"_314ec61998","main":"_79ee9e5629","btn":"_3f81a28492","w":"_8d7ee133f9","h":"_64f793a4e9","lh25":"_90877f3aa4","wb":"ceccf92873","b":"_5c5004d13b","bx":"d015f6a00b"};